export const prepareQuery = (filters: Record<string, any>) => {
  let str = "?"
  Object.entries(filters).forEach(([key, value]) => {
    str += `${key}=${value}&`
  })
  return str.slice(0, -1)
}
